import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

export default class extends Controller {
  static targets = ["text"]
  
  connect() {
    this.messages = [
      i18n.t('ai_loading.thinking'),
      i18n.t('ai_loading.analyzing'),
      i18n.t('ai_loading.summarizing'),
      i18n.t('ai_loading.generating'),
    ]
    this.currentIndex = 0
    this.startAnimation()
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  startAnimation() {
    // Initial display
    this.updateText()

    // Cycle through messages every 1.5 seconds
    this.intervalId = setInterval(() => {
      this.fadeOut(() => {
        this.currentIndex = (this.currentIndex + 1) % this.messages.length
        this.fadeIn()
      })
    }, 1500)
  }

  updateText() {
    this.textTarget.textContent = this.messages[this.currentIndex]
  }

  fadeOut(callback) {
    this.textTarget.style.opacity = "0"
    setTimeout(() => {
      this.updateText()
      callback()
    }, 300)
  }

  fadeIn() {
    setTimeout(() => {
      this.textTarget.style.opacity = "1"
    }, 50)
  }
}
